import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { format } from 'date-fns';
import './MyModal.css'
function UserModal({ elements }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    
    const [ownersInsurancePolicy, setOwnersInsurancePolicy] = useState(elements.ownersInsurancePolicy ? process.env.REACT_APP_UPLOAD_URL + elements.ownersInsurancePolicy : '');
    const [govermentIssuedID, setGovermentIssuedID] = useState(elements.govermentIssuedID ? process.env.REACT_APP_UPLOAD_URL + elements.govermentIssuedID : '');



    const openPDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.add('show');
        document.getElementById('pdfPreviewModal').style.display = 'block';
    };

    const closePDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.remove('show');
        document.getElementById('pdfPreviewModal').style.display = 'none';
    };


    const openPDFTwoModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModalTwo').classList.add('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'block';
    };

    const closePDFTwoModal = () => {
        document.getElementById('pdfPreviewModalTwo').classList.remove('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'none';
    };

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                View
            </Button>

            <Modal show={show} onHide={handleClose} className='modal-lg'>
                <Modal.Header className='justify-content-between'>
                    <Modal.Title>{elements.firstname ? elements.firstname : ''} {elements.lastname ? elements.lastname : ''}</Modal.Title>
                    <Button variant="default" onClick={handleClose}>
                        <i className='la la-close'></i>
                    </Button>

                </Modal.Header>
                <Modal.Body>
                    <table className="table">
                        <tbody>
                            <tr>
                                <th>Email</th>
                                <td>
                                    {elements.email ? elements.email : ''}
                                </td>
                            </tr>

                            <tr>
                                <th>Phone</th>
                                <td>
                                    <span className={elements.isPhoneVerify === '1' ? 'text-info' : 'text-danger'}>
                                        {elements.phoneNumber ? elements.phoneNumber : ''}
                                    </span>
                                </td>
                            </tr>

                            <tr>
                                <th>Email</th>
                                <td>
                                    <span className={elements.stripe_verified === '1' ? 'text-info' : 'text-danger'}>
                                        {elements.stripeEmail ? elements.stripeEmail : ''}<br />
                                        {elements.stripe_id ? elements.stripe_id : ''}
                                    </span>
                                </td>
                            </tr>

                            <tr>
                                <th>Address</th>
                                <td>
                                    {elements.mailingAddress ? elements.mailingAddress : ''}
                                </td>
                            </tr>

                            <tr>
                                <th>City</th>
                                <td>
                                    {elements.city ? elements.city : ''}
                                </td>
                            </tr>

                            <tr>
                                <th>State</th>
                                <td>
                                    {elements.state ? elements.state : ''}
                                </td>
                            </tr>

                            <tr>
                                <th>Zipcode</th>
                                <td>
                                    {elements.zipCode ? elements.zipCode : ''}
                                </td>
                            </tr>

                            <tr>
                                <th>DOB</th>
                                <td>
                                    {elements.birthday ? elements.birthday : ''}
                                </td>
                            </tr>
                            <tr>
                                <th>SSN</th>
                                <td>
                                    {elements.SSN ? elements.SSN : ''}
                                </td>
                            </tr>
                            <tr>
                                <th>UserType</th>
                                <td>
                                    {elements.userType ? elements.userType : ''}
                                </td>
                            </tr>

                            <tr>
                                <th>ownersInsurancePolicy</th>
                                <td>
                                {ownersInsurancePolicy &&
                                                                        <button type="button" className="btn btn-primary btn-lg" onClick={openPDFModal}>View Insurance</button>
                                                                    }
                                </td>
                            </tr>
                            <tr>
                                <th>govermentIssuedID</th>
                                <td>
                                    {govermentIssuedID &&
                                        <button className="btn btn-primary btn-lg" onClick={openPDFTwoModal}>View Issued ID</button>
                                    }

                                </td>
                            </tr>

                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    {/* <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
                </Modal.Footer>
            </Modal>
            {ownersInsurancePolicy &&
                <div className="modal fade" id="pdfPreviewModal" tabIndex="-1" role="dialog" style={{zIndex:1099}}>
                    <div className="modal-dialog modal-xxl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Owners Insurance Policy</h5>
                                <button type="button" className="btn-close close" data-dismiss="modal" aria-label="Close" onClick={closePDFModal}>
                                    <span aria-hidden="true"></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <embed src={ownersInsurancePolicy} type="application/pdf" width="100%" height="500px" />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            }


            {govermentIssuedID &&
                <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog" style={{zIndex:1099}}>
                    <div className="modal-dialog modal-xxl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Goverment Issued ID</h5>

                                <button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close" onClick={closePDFTwoModal}>
                                    <span aria-hidden="true"></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <embed src={govermentIssuedID} type="application/pdf" width="100%" height="500px" />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFTwoModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </div>
    );
}

export default UserModal;
